import React from 'react';
import ReactDOM from 'react-dom';
import 'react-toastify/dist/ReactToastify.css';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import './index.css';
import 'react-pdf/src/Page/AnnotationLayer.css';
import { polyfill as scrollIntoView } from 'seamless-scroll-polyfill';

import App from './App';

scrollIntoView();

if (document.getElementById('root')) {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('root')
  );
}
